import React from "react";
import CourseTopicMaterials from "../../../../hooks/CourseTopicMaterials";
import { thirdFormCourseTopicMaterials } from "../../../../shared/components/FormCourseMaterials/FormCourseMaterials";
import { thirdFormTextBooks } from "../../../../shared/components/FormCourseMaterials/FormImages";
import TextBookImages from "../../../../shared/components/TextBookImages/TextBookImages";

import pic5 from '../../../../assets/Images/PageDetails/ThirdForm/Picture5.webp';
import pic6 from '../../../../assets/Images/PageDetails/ThirdForm/Picture6.webp';


const ThirdFormContent = () => {
  return (
    <>
      <CourseTopicMaterials items={thirdFormCourseTopicMaterials} leftImage={pic5} rightImage={pic6} /> 
      <TextBookImages images={thirdFormTextBooks} form='Third' />
    </>
  );
}

export default ThirdFormContent;
